import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import Sidebar from "../Components/Sidebar";
import VideoCard from "../Components/VideoCard";
import BackButton from "../Components/BackButton";
import GlobalAlert from '../Components/GlobalAlert';
import { useLocation } from "react-router-dom";

export default function SingleVideo() {
  const [data, setData] = useState([]);
  const location = useLocation();
  const { video, category } = location.state || {}; // Handle undefined state

  const [videoUrl, setVideoUrl] = useState("");
  const videoRef = useRef(null); // Reference to the video element

  function fetchData() {
    fetch(
      "https://apiv2.mobileartsme.com/av_getcontent?apisource=1&phonenumber=96170932819&ispremium=true&language=en&country=LB"
    )
      .then((response) => response.json())
      .then((data) => {
        const videos = data.Content?.[0]?.Videos || [];
        setData(videos);
        sessionStorage.setItem("av_data", JSON.stringify(videos));
        console.log("Fetched Videos:", videos);
      })
      .catch(error => console.error("Error fetching data:", error));
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const sessionData = JSON.parse(sessionStorage.getItem("av_data"));
    if (sessionData) {
      setData(sessionData);
    } else {
      fetchData();
    }

    if (video?.ID) {
      getVideoUrl(video.ID).then((url) => {
        console.log("Fetched Video URL:", url);
        setVideoUrl(url);
      });
    }

  }, [video, category]);



  useEffect(() => {
    if (videoUrl && videoRef.current) {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoUrl);
        hls.attachMedia(videoRef.current);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("HLS manifest loaded");
        });
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        // Native HLS support (Safari)
        videoRef.current.src = videoUrl;
      } else {
        console.error("HLS format is not supported in this browser.");
      }
    }
  }, [videoUrl]);





  async function getVideoUrl(id) {
    try {
      const response = await fetch(`https://apiv2.mobileartsme.com/av_geturl?videoId=${id}`);
      const res = await response.json();
      return res.result; // Ensure this URL is in .m3u8 format
    } catch (error) {
      console.error("Error fetching video URL:", error);
      return "";
    }
  }

  return (
    <div className="single-video-page">
      <GlobalAlert />
      <Sidebar data={data} />

      <div className="main-body">
        <div className="container">
          <BackButton />
          <h2 className="spangreen bold">{category?.Name || ''}</h2>

          <div className="video-player w-100">
            <h2 className="video-title" style={{ fontWeight: '300' }}>{video?.Title}</h2>

            <video
              ref={videoRef}
              controls
              autoPlay
              
              poster={video?.Thumbnail} />
          </div>

          {category?.Content?.length > 0 && (
            <div className="related-videos">
              <h3 className="my-4 mt-5">Related Videos</h3>
              <div className="related-video-list">
                {category.Content.map((vid, index) => (
                  <VideoCard key={index} video={vid} category={category} layout="list" />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
